import React from 'react';
import PropTypes from 'prop-types';

const LoginContext = React.createContext(null);

export const useLogin = () => {
  const context = React.useContext(LoginContext)
  if (context === undefined) {
    throw new Error('useLogin must be used within a LoginProvider')
  }
  return context
}

export function LoginProvider({ value, children }) {
  return (
    <LoginContext.Provider value={value}>
      {children}
    </LoginContext.Provider>
  )
}

LoginProvider.propTypes = {
  value: PropTypes.shape(),
  children: PropTypes.node,
}

